export default __webpack_public_path__ + "static/media/property_361.9ad62b17.png";